import { BrowserBreadcrumbTypes, DomTypes, EventTypes } from '@heimdallr-sdk/types';
import { formatDate, generateUUID, throttle } from '@heimdallr-sdk/utils';
import { htmlElementAsString } from './utils';
function domPlugin(options) {
    if (options === void 0) { options = {}; }
    return {
        name: 'domPlugin',
        monitor: function (notify) {
            var _a = options.throttleDelayTime, throttleDelayTime = _a === void 0 ? 300 : _a;
            var clickThrottle = throttle(notify, throttleDelayTime);
            document.addEventListener('click', function (e) {
                clickThrottle({
                    category: DomTypes.CLICK,
                    data: e.target
                });
            }, true);
        },
        transform: function (collectedData) {
            var category = collectedData.category, data = collectedData.data;
            var htmlString = htmlElementAsString(data);
			console.log(data.__vue__&& data.__vue__.$listeners)
			if(!data.__vue__) { // vue节点同时监听了事件
				return null;
			}else if(Object.keys(data.__vue__.$listeners).length == 0) {
				return null;
			}
            if (!htmlString) {
                return null;
            }
            var id = generateUUID();
            this.breadcrumb.unshift({
                eventId: id,
                type: BrowserBreadcrumbTypes.CLICK,
                message: "Click ".concat(htmlString)
            });
            return {
                id: id,
                time: formatDate(),
                type: EventTypes.DOM,
                data: {
                    sub_type: category,
                    ele: htmlString
                }
            };
        }
    };
}
export default domPlugin;
